export const AuthError = {
  '0000': {
    name: 'AuthError',
    message: '用户信息已过期',
    code: '0000'
  },
  '0001': {
    name: 'AuthError',
    message: '获取用户信息失败(w)',
    code: '0001'
  }
}


// WEBPACK FOOTER //
// ./src/DATA/error.js